// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"185":"33d133a14b46d1b98e19","695":"aeedd66d0b33118f722f","829":"f9bc94e358f394afde14","874":"6e84c0048a33e8625781"}[chunkId] + ".js";
};